module.exports = __webpack_public_path__ + "images/tbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tbc.png
// module id = 47
// module chunks = 0